import { For, Show } from "solid-js";
import type { EventColumnProps } from "../_model";
import EventCard from "./event-card";

export default function Column(props: EventColumnProps) {
  return (
    <div class="flex flex-col min-w-25.1vw w-25.1vw min-h-fit max-w-25.1vw h-fit bg-bg-alt px-1 py-2 rounded-2xl lt-md:(!min-w-full !w-full !max-w-full h-full)">
      <div class="flex flex-row justify-center items-center justify-between px-2 text-18px py-2 border-b-2 border-solid border-border-input">
        <span class="font-bold text-text">{props.year}</span>
        <p class="text-brand font-bold">
          {props.day} {props.monthName}
        </p>
        <span class="font-bold text-text">{props.dayOfWeek}</span>
      </div>
      <div>
        <Show when={props?.events}>
          <For each={props?.events}>
            {(event) => {
              return <EventCard {...event} />;
            }}
          </For>
        </Show>
      </div>
    </div>
  );
}
